import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IPagination, IPaginationResult } from "app/common/interfaces";
import { ActiveSchemaConfig } from "./schema-service.resolver";
import { andWhere, buildQuery, FilterFn, Ops, orderBy, OrderVariant, orWhere, page, where } from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/status.enum";

@Injectable({ providedIn: 'root' })
export class GenericActiveLookupService {

  constructor(private http: HttpClient) {}

  findAll(config: ActiveSchemaConfig, options: IPagination<any>) {

    const hasSearch = !!options.search;

    const buildBaseFilters = (useOrWhere: boolean): FilterFn<any>[] => {
      const deletedFilter = useOrWhere
        ? orWhere('_deleted', Ops.eq(false))
        : where('_deleted', Ops.eq(false));

      return [
        deletedFilter,
        andWhere('statusId', Ops.in(...[StatusEnum.ACTIVE]))
      ];
    };

    const searchQueries = config.searchFields.flatMap((field, index) => {

      if (!hasSearch) return [];

      return [
        ...buildBaseFilters(index !== 0),
        andWhere(field as string, Ops.like(options.search!, 'i'))
      ];
    });

    const baseQuery = buildBaseFilters(false);

    const query = buildQuery(
      ...baseQuery,
      ...searchQueries,
      orderBy(
        options.sort ?? config.defaultSort,
        options.sortDirection === 'ASC' ? OrderVariant.Asc : OrderVariant.Desc
      ),
      page(options.currentPage ?? 1, options.limitPerPage ?? 100)
    );

    const url =
      `${config.apiUrl}api/${config.moduleName}/withCount?filter=${encodeURIComponent(JSON.stringify(query))}`;

    return this.http.get<IPaginationResult<any>>(url);
  }
}